export const environment = {
  production: true,
  apiUrl: "https://api.spielogui.de/api/"
};
